import { graphql, useStaticQuery } from 'gatsby';
import uniq from 'lodash/uniq';

const teacherInfoQuery = graphql`
  query OnlineCourseTeacherQueries {
    allGoogleSpreadsheetDolLandingPageMarLevelData(
      filter: { classGroup: { eq: "IELTS Online" } }
    ) {
      edges {
        node {
          levelVideo
          availableSeat
          classCode
          classDate
          classGroup
          classListing
          classTime
          inputLevel
          level
          levelDescription
          levelDisplay
          outputLevel
          startDate
          teacherRw
          teacherSl
          levelSubtext
          levelInputOutputMobile
          levelInputOutputDesktop
        }
      }
    }
  }
`;

export const useTeacherOnlineData = () => {
  const data = useStaticQuery(teacherInfoQuery);
  const levels = uniq(
    data.allGoogleSpreadsheetDolLandingPageMarLevelData.edges.map(
      item => item.node.level
    )
  );
  return levels;
};
